/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{align-items:center;background:rgba(255,255,255,.7);bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0;z-index:10}"];
export { styles as styles };
